import { useSetAtom } from "jotai";
import { useModals } from "src/components/Modals";
import { updateStoreProductsModalDataAtom } from "./atoms";
import { ResponseGetMerchflows_merchflowId_StoresAll } from "@CommonApi/merchflows/_merchflowId_/stores/all";

export const useUpdateStoreProductsModal = () => {
  const { openModal } = useModals();
  const setData = useSetAtom(updateStoreProductsModalDataAtom);

  const openUpdateStoreProductsModal = (
    data: ResponseGetMerchflows_merchflowId_StoresAll,
    merchflowId: number,
  ) => {
    setData({ data, merchflowId });
    openModal("UpdateStoreProductsModal");
  };

  return { openUpdateStoreProductsModal };
};
